import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Header from './Header'
import Name from './Name'
import City from './City'
import Target from './Target'
import Date from './Date'
import Description from './Description'
import PopUp from './PopUp'
import {ButtonTestCss} from "../../ButtonStyle";
import CircularProgress from '@material-ui/core/CircularProgress';
import {CheckFormatDate} from '../../Moment/Moment'
import {Requestdynamic} from '../../Network/Fetch';
import { EditorState, convertToRaw } from "draft-js";
import Cookies from 'universal-cookie'
import SelectEventModal from './SelectEventModal';


class AddGallery extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        City: "",
        Target: "FR",
        addGallery: false,
        Year: null,
        Day: null,
        Month: null,
        Error: null,
        Name: null,
        Editor: EditorState.createEmpty(),
        openModal: false,
        title: null,
        message: null,
        success: false,

        eventId: null,
        openSelectEventModal: false,
        loadingEvent: false,
        events: [],
        pagination: {
          limit: 5,
          lastKey: null,
        },
        selectedEvent: null,
        eventLoadError: false,
      }
      this.eventCardRef = React.createRef();

    }


    componentDidMount() {

      const searchParams = new URLSearchParams(this.props.navigation.location.search);
      const eventIdFromUrl = searchParams.get("eventId");

      if (eventIdFromUrl) {
        this.setState({
          eventId: eventIdFromUrl,
          openSelectEventModal: true
        });
      } else {
        this.setState({ openSelectEventModal: true });
      }
}

    _handleEventSelect = (event) => {
  if (event && event.DateEvent && event.Name) {
    const [year, month, day] = event.DateEvent.split('/');
    this.setState((prevState) =>  ({
      Name: event.Name,
      Year: year,
      Month: month,
      Day: day,
      selectedEvent: event,
      Error: { ...prevState.Error, Event: false }
    }));
  }
};

    _closeEventModal = () => {
      this.setState({ openSelectEventModal: false });
    };


    _ConvertToRaw = (Error) => {
      try {
        if (!this.state.Editor)
          return (null)
        var RawEditor = convertToRaw(this.state.Editor.getCurrentContent())
        return (RawEditor)
      } catch (e) {
        return ("erreur")
      }

    }

    _CheckDate = (Error) => {
      if (!this.state.Year || !this.state.Month || !this.state.Day)
      {
        Error.Date = true
        return ;
      }
      var Date = this.state.Year + '/' + this.state.Month + '/' + this.state.Day
      if (!CheckFormatDate(Date, "YYYY/MM/DD"))
        Error.Date = true
      return ;
    }


    _CheckName = (Error) => {
      if (!this.state.Name || this.state.Name.length === 0)
        Error.Name = true
    }

    sleep = (ms) => {
     return new Promise(resolve => setTimeout(resolve, ms));
   }

    _addGallery = async () => {
    this.setState({addGallery: true, Error: null}, async() => {
    var Error = {};
    if (!this.state.selectedEvent) {
      Error.Event = true;
    }
    if (Error.Event && this.eventCardRef.current) {
      this.eventCardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this._CheckDate(Error)
    this._CheckName(Error)

    var Description = this._ConvertToRaw()

    var KeysErrorLength = Object.keys(Error).length
    if (KeysErrorLength !== 0)
    {
      this.setState({Error: Error, addGallery: false})
      return ;
    }
    var cookies = new Cookies();
    var Jwt = cookies.get('acces');
    var City = this.state.City.length === 0 ? null : this.state.City
    var Params = {
      Target: this.state.Target,
      City: City,
      Name: this.state.Name,
      Date: this.state.Year + '/' + this.state.Month + '/' + this.state.Day,
      Jwt: Jwt,
      Description: Description,
      EventId: this.state.selectedEvent.Id,
    }
    var promise = await Requestdynamic('_addGallery', Params)
    if(promise.error === false && promise.data.error === false)
    {
      this.setState({
         success: true,
         openModal: true,
         title: 'Success',
         message: "La gallerie à bien été crée",
         City: "",
         Target: "FR",
         Year: null,
         Day: null,
         Month: null,
         Error: null,
         Name: null,
         Editor: EditorState.createEmpty(),
         selectedEvent: null,
         selectedEventId: null,
         eventId: null,
         openSelectEventModal: false,
         addGallery: false,
       });
    }
    else
    {
      if (promise.error === true)
        this.setState({addGallery: false, openModal: true, title: 'Error', message: "Un problème est survenue veuillez réesayer plus tard"})
      else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true)
      {
        cookies = new Cookies();
        cookies.remove('acces', { path: '/' })
        cookies.remove('infoAdmin', { path: '/' })
        await this.sleep(900)
        var url = '/login'
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return ;
      }
      else
        this.setState({addGallery: false, openModal: true, title: 'Error', message: "Un problème est survenue veuillez réesayer plus tard"})
      return ;
    }
  })

}

renderSelectedEventCard = () => {
  const event = this.state.selectedEvent;

  return (
    <div className="d-flex mt-3 justify-content-center">
      <div
      ref={this.eventCardRef}
        className="card p-3 mb-4 shadow-sm"
        style={{
          maxWidth: '700px',
          width: '100%',
          height: '150px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          border: this.state.Error?.Event ? '2px solid red' : 'none'
        }}
      >
      <h6 className="text-muted mb-2">Événement lié :</h6>
         {

    this.state.selectedEvent ? <>
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center" style={{ height: '100%' }}>
        <div
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '8px',
            overflow: 'hidden',
            marginRight: '16px',
            flexShrink: 0,
          }}
        >
          <img
            src={event.Image}
            alt={event.Name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div>
          <h5 className="mb-1">{event.Name}</h5>
          <p className="mb-0 text-muted">{event.DateEvent}</p>
        </div>
      </div>
      <ButtonTestCss
        size="sm"
        color="#082430"
        onClick={() => this.setState({ openSelectEventModal: true })}
      >
        Modifier
      </ButtonTestCss>
    </div>
    </>
    : (
      <div className="text-center my-4">
        <ButtonTestCss
          color="orange"
          onClick={() => this.setState({ openSelectEventModal: true })}
        >
          Sélectionner un événement
        </ButtonTestCss>
      </div>
    )
}
{this.state.Error?.Event && (
<div className="text-danger mt-2" style={{ fontWeight: '500' }}>
Veuillez sélectionner un événement pour continuer.
</div>
)}

      </div>
    </div>
  );
};


render() {
   return (
     <div style={{ marginLeft: 10, overflowY: "auto" }}>
       <Container fluid>
         <SelectEventModal
           show={this.state.openSelectEventModal}
           prefillEventId={this.state.eventId}
           onSelect={this._handleEventSelect}
           onClose={this._closeEventModal}
         />

         <PopUp
           Editor={this.state.Editor}
           success={this.state.success}
           openModal={this.state.openModal}
           message={this.state.message}
           title={this.state.title}
           refParent={this}
         />

         <Header intl={this.props.intl} />

         {this.renderSelectedEventCard()}

         <Name Error={this.state.Error} intl={this.props.intl} Name={this.state.Name} refParent={this} />
         <City Error={this.state.Error} intl={this.props.intl} City={this.state.City} refParent={this} />
         <Target Error={this.state.Error} intl={this.props.intl} Target={this.state.Target} refParent={this} />
         <Date
           Error={this.state.Error}
           intl={this.props.intl}
           Year={this.state.Year}
           Day={this.state.Day}
           Month={this.state.Month}
           refParent={this}
         />
         <Description intl={this.props.intl} Editor={this.state.Editor} refParent={this} />

         <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Col xl={12} lg={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ButtonTestCss
                disabled={this.state.addGallery}
                color={"orange"}
                style={{ margin: 10 }}
                onClick={this._addGallery}
              >
                {this.state.addGallery ? (
                  <CircularProgress size={"1.5rem"} thickness={5} color={"inherit"} />
                ) : (
                  <p style={{ margin: 0, padding: 0 }}>Ajouter</p>
                )}
              </ButtonTestCss>
            </Col>
          </Row>
       </Container>
     </div>
   );
 }
}


export default AddGallery;
